export const QS_LOCAL_STORAGE_KEY = 'saved_qs';
export const UPS_SAVINGS_MODAL_DISMISSED = 'ups_savings_modal_dismissed';
export const UPS_SAVINGS_MODAL_DISMISS_DATA = 'ups_savings_modal_data';
export const WIX_PRO_PLAN_NOTIFICATION_DISMISSED = 'wix_pro_plan_notification_dismissed';
export const BTF_NOTICE_LAST_SEEN = 'btf_notice_last_seen';
export const IBD_MODAL_ROLLOUT_DISMISSED = 'ibd_modal_rollout_dismissed';
export const STORE_CONNECTION_INITIATED = 'store_connection_initiated';
export const SELECTED_ONBOARDING_EXIT = 'selected_onboarding_exit';
export const SETUP_ACCOUNT_CHECKLIST_ENABLED = 'setup_account_checklist_enabled';
export const LS_ACCOUNT_SETUP_STATE = 'account_setup_state';
export const SSO_NEXT_REDIRECT_SESSION_KEY = 'sso_next_redirect_url';
export const SSO_QUERY_PARAMS_SESSION_KEY = 'sso_query_params';
export const CSV_EXPORT_RESULTS_KEY = 'CSVExportResults';
export const HUB_ACTIONS_DISMISSED_KEY = 'hub-basics-dismissed';
